import {measure} from './promise-fastdom';

const _ = new WeakMap();

export default function BreakpointObserver(name) {
    
    const o = {};

    o.callbacks = [];

    o.ready = Promise.resolve()
        .then(measure(() => window.getComputedStyle(document.documentElement)))
        .then((style) => {
            o.query = window.matchMedia(`(min-width:${style.getPropertyValue(`--breakpoint-${name}`)})`);
        });

    o.run = callback => callback.call(this, o.query);

    o.handler = () => {
        for (const callback of o.callbacks) {
            o.run(callback);
        }
    };
    
    o.listen = () => {
        o.ready.then(() => o.query.addEventListener('change', o.handler));
    };
    
    o.unlisten = () => {
        o.ready.then(() => o.query.removeEventListener('change', o.handler));
    }

    _.set(this, o);
}

BreakpointObserver.prototype.ready = function () {
    return _.get(this).ready;
};


BreakpointObserver.prototype.observe = function (callback) {
    // add observer
    const o = _.get(this);
    o.callbacks.push(callback);
    o.ready.then(() => o.run(callback));

    // add listeners
    o.callbacks.length === 1 && o.listen();
};

BreakpointObserver.prototype.unobserve = function (callback) {
    // remove observer
    const o = _.get(this);
    const index = o.callbacks.indexOf(callback);
    if (index !== -1) {
        o.callbacks.splice(index, 1);
    }

    // remove listeners
    o.callbacks.length === 0 && o.unlisten();
};

BreakpointObserver.prototype.destroy = function () {
    const o = _.get(this);
    o.unlisten();
    _.delete(this);
}